import { Profile } from 'flow/types/Profile';
import { TypedMap } from 'flow/types/TypedMap';
import React, { MouseEventHandler } from 'react';
import Page from '../../Page';
import { Disconnect as DisconnectLogic } from '../components/CallSettings';

interface Props {
    profile: TypedMap<Profile>;
    onClickBack: MouseEventHandler;
}

const Disconnect = ({ profile, onClickBack }: Props) => (
    <Page
        onClickBack={onClickBack}
        header="settings.incoming_calls.disconnected"
    >
        <DisconnectLogic profile={profile} />
    </Page>
);

export default Disconnect;
